var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-container"},[_c('h2',{staticClass:"header-title"},[_vm._v(_vm._s(_vm.name)+" "+_vm._s(_vm.route ? `- ${_vm.route}` : ""))]),_c('p',{staticClass:"subHeader"},[_vm._v(_vm._s(_vm.subHeader))])])
}
var staticRenderFns = []

export { render, staticRenderFns }